import { AdminPageLayout } from "@/features/admin/components/AdminPageLayout";
import { ReminderSequenceDemo } from "@/features/developer/reminder-sequences/ReminderSequenceDemo";
import { useNav } from "@/utils/nav";
import { createFileRoute, Link } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/design/features/reminder-sequences")({
    component: ReminderSequencesPage,
});

function ReminderSequencesPage() {
    useNav([
        { label: "Design", route: { to: "/design" } },
        { label: "Reminder sequences", route: { to: "/design/features/reminder-sequences" } },
    ]);

    return (
        <AdminPageLayout
            title="Reminder sequences"
            description="Edit the invite and reminder messages, their rules and their variables."
            headerActions={
                <Link
                    to="/design/features/messaging-schedule"
                    className="text-sky-700 text-sm hover:underline underline-offset-2"
                >
                    Current Knock schedule
                </Link>
            }
        >
            <ReminderSequenceDemo />
        </AdminPageLayout>
    );
}
